import { FC, useState } from 'react';

import Box from '@mui/material/Box/Box';

import { Layout } from 'components/Layout';
import { MetaHead } from 'components/MetaHead';
import { ContactModal } from 'components/Header/ContactModal';

import Hero from './Hero/Hero';
import AILSV2 from './AILSV2/AILSV2';
import TextWithImage from './TextWithImage/TextWithImage';
import WhyChooseUs from './WhyChooseUs/WhyChooseUs';
import Carousel from './Carousel/Carousel';
import { ApplicationNavigation } from './ApplicationNavigation/ApplicationNavigation';
import { useIsMobile } from 'hooks/useIsMobile';

import { IFullApplicationsData } from 'constants/applications/all-applications-data';
import { colors } from 'styles';
import {
  LeftTriangle,
  LeftTriangleTop,
  RightTriangle,
  RightTriangleTop,
} from 'components/HeroSection/HeroSection.styles';

export const ApplicationTemplate: FC<IFullApplicationsData> = ({ pageMeta, data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobile = useIsMobile();

  const toggleModal = () => {
    setIsModalOpen((value) => !value);
  };

  return (
    <>
      <MetaHead pageMeta={pageMeta} />

      <Layout>
        <Hero {...data.hero} />

        <Box
          display="flex"
          justifyContent="center"
          paddingBottom={{
            md: '220px',
            sm: '107px',
            xxs: '107px',
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            maxWidth="1200px"
            padding={{
              lg: '112px 0',
              sm: '112px 0',
              xxs: '112px 16px',
            }}
          >
            <ApplicationNavigation />
            <Box id="key-challenges">
              <TextWithImage {...data.firstTextImageData} />
            </Box>
          </Box>
        </Box>
        <Box display="flex" justifyContent="center" bgcolor={colors.mainDark} position="relative">
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            maxWidth="1200px"
            padding={{
              lg: '0',
              sm: '0 24px',
              xxs: '0 16px',
            }}
          >
            <LeftTriangleTop />
            <RightTriangleTop />
            <LeftTriangle />
            <RightTriangle />
            <Box id="key-capabilities">
              <AILSV2 {...data.informationData} />
            </Box>
          </Box>
        </Box>
        <Box display="flex" justifyContent="center">
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            maxWidth="1200px"
            padding={{
              lg: '0',
              sm: '0 24px',
              xxs: '0 16px',
            }}
          >
            <Box id="why-choose-us">
              <WhyChooseUs {...data.whyChooseUsData} />
            </Box>
            <Box marginTop={isMobile ? '112px' : '0px'} />
            {data.secondTextImageData && (
              <TextWithImage type="customer-case" {...data.secondTextImageData} />
            )}

            {data.carouselData && <Carousel items={data.carouselData} />}
          </Box>
        </Box>
      </Layout>

      <ContactModal onClose={toggleModal} isOpen={isModalOpen} />
    </>
  );
};
